import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {AppNameEnum, FrontendDocument, NachdigalService} from '@nachdigal';
import {DateHelper} from '@utils-lib';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypResolver implements Resolve<unknown> {
  constructor(private readonly documentService: NachdigalService, private readonly router: Router) {
  }

  private static getDocumentRoutPart(appName: AppNameEnum): string {
    switch (appName) {
      case 'Fragebogen_EUn':
        return 'fragebogen-eun';
      case 'Fragebogen_KapG':
        return 'fragebogen-kap-ges';
      case 'Fragebogen_BetPG':
        return DateHelper.isDateOlderThanDeadline() ? 'fragebogen-betpg' : 'termination-message';
      case 'Fragebogen_KapGAus':
        return 'fragebogen-kapg-aus';
      case 'Fragebogen_PersG':
        return 'fragebogen-pers-ges';
      default:
        return '';
    }
  }

  resolve(route: ActivatedRouteSnapshot): Observable<FrontendDocument> {
    const taskId = route.paramMap.get('taskId');
    if (taskId) {
      return this.documentService.getFrontendDocument(taskId).pipe(tap((data: FrontendDocument): void => {
        const appName = data?.element_of_order?.app_name;
        if (appName) {
          const documentRoutPart = DocumentTypResolver.getDocumentRoutPart(appName);
          if (data.status === 'sending_error' || data.status === 'sending_confirmed' || data.status === 'sending') {
            this.router.navigate([documentRoutPart, taskId, 'antrag-versenden']).then(() => {}).catch(() => {});
          }else {
            this.router.navigate([documentRoutPart, taskId]).then(() => {}).catch(() => {});
          }
        } else {
          this.router.navigate(['forbidden', '403']).then(() => {}).catch(() => {});
        }
      }));
    }
    return null;
  }
}
